import React, { forwardRef, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import "./erf_Printout.scss";

const ClosureRefundFormPrintout = forwardRef((props, ref) => {
  //   const appConfig = useSelector((state) => state?.app?.appConfig);
  // eslint-disable-next-line
  const [data, setData] = useState({});

  useEffect(() => {
    if (props?.data) {
      setData(props.data);
    }
  }, [props]);

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    }).replace(/ /g, '-');
  };

  // Calculate refund amount if available
  const getRefundAmount = () => {
    if (data?.refundAmount) {
      return `₹${data.refundAmount}`;
    }
    if (data?.balanceSecurityAmt && data.balanceSecurityAmt < 0) {
      return `₹${Math.abs(data.balanceSecurityAmt)}`;
    }
    return "__________";
  };

  // Get payment mode
  const getPaymentMode = () => {
    if (data?.securityMode) {
      return data.securityMode;
    }
    if (data?.paymentMode) {
      return data.paymentMode;
    }
    return "NR";
  };

  return (
    <>
      <div ref={ref} className="formContainer mb-5 pb-5">
        <div className="max-w-5xl mx-auto bg-white p-10 shadow-lg">
          {/* <!-- Header --> */}
          <div className="flex justify-between items-center mb-8">
            <div>
              <div>
                <img
                  src="/assets/img/medirent/printoutimage/mediretnlogo.jpg"
                  alt="Medical Equipment Header"
                  className="img"
                />
              </div>
            </div>
            <h2 className="text-2xl font-bold uppercase">
              Security Refund Form
            </h2>
          </div>

          {/* <!-- Top Section --> */}
          <div className="grid grid-cols-2 gap-8 text-sm">
            {/* <!-- Left Column --> */}
            <div className="space-y-2">
              <p>
                <span className="font-semibold">Date :</span> {formatDate(data?.orderDate) || "09-Feb-2026"}
              </p>
              <p>
                <span className="font-semibold">Agreement Date :</span>{" "}
                {formatDate(data?.erfStartDate) || "29-Jan-2026"}
              </p>
              <p>
                <span className="font-semibold">Agreement Closure Date :</span>{" "}
                {formatDate(data?.erfEndDate) || "28-Feb-2026"}
              </p>

              <p className="mt-4">
                <span className="font-semibold">Cost Center :</span> {data?.costCenter || "CCN AT HOME"}
              </p>

              <p className="mt-4">
                <span className="font-semibold">Customer's Name :</span> {data?.patientName || "IQBAL SINGH"}
              </p>
              <p>
                <span className="font-semibold">Email Id :</span>{" "}
                {data?.email || data?.emailId || "INFO@MEDIRENT.IN"}
              </p>
              <p>
                <span className="font-semibold">Patient's Name :</span> {data?.patientName || "IQBAL SINGH"}
              </p>
              <p>
                <span className="font-semibold">Age :</span> {data?.age || "-"}
              </p>

              <p className="mt-4">
                <span className="font-semibold">Billing Address :</span>
                <br />
                {data?.billingAddress || "APP 1204 TOWER E BESTECH ALTURA SEC 79 GGN"}
              </p>

              <p>
                <span className="font-semibold">Delivery Address :</span>
                <br />
                {data?.deliveryAddress || "APP 1204 TOWER E BESTECH ALTURA SEC 79 GGN"}
              </p>

              <p>
                <span className="font-semibold">Pending Amount (if any):</span>{" "}
                {data?.balanceAmount ? `₹${data.balanceAmount}` : "__________"}
              </p>
            </div>

            {/* <!-- Right Column --> */}
            <div className="space-y-2">
              <p>
                <span className="font-semibold">ERF S.No. :</span> {data?.documentNumber || data?.equipmentRentNr || "CCNO-168/2526"}
              </p>
              <p>
                <span className="font-semibold">Bill No. :</span> {data?.billNo || "PMSOG-01107"}
              </p>
              <p>
                <span className="font-semibold">PCE Code :</span> {data?.rentItems?.[0]?.storageLocn || "MASTER STORE"}
              </p>

              <p className="mt-4">
                <span className="font-semibold">Relationship :</span> {data?.caregiverRelation || "-"}
              </p>
              <p>
                <span className="font-semibold">Customer's Phn No. :</span>{" "}
                {data?.mobileNr || "XXXXXXXX04"}
              </p>
              <p>
                <span className="font-semibold">Patient's No. :</span>{" "}
                {data?.mobileNr || "XXXXXXXX04"}
              </p>

              <p className="mt-12">
                <span className="font-semibold">Cash Receipt No. :</span>{" "}
                {data?.receiptNo || "CCNRCO-168/2526"}
              </p>
            </div>
          </div>

          {/* <!-- Rental Security Section --> */}
          <div className="mt-10">
            <h3 className="font-bold text-md uppercase mb-4">
              Rental of Security Amount to be Refunded
            </h3>

            <div className="text-sm space-y-2">
              <p>
                <span className="font-semibold">Payment Mode :</span> {getPaymentMode()}
              </p>
              {data?.balanceSecurityAmt === 0 || !data?.balanceSecurityAmt ? (
                <p className="underline font-semibold">
                  Security amount not received
                </p>
              ) : (
                <p className="underline font-semibold">
                  Security amount received
                </p>
              )}
              <p>
                <span className="font-semibold">Total Security Amount :</span>{" "}
                {data?.receivedSecurityAmt ? `₹${data.receivedSecurityAmt}` : "__________"}
              </p>
              <p>
                <span className="font-semibold">Amount Refunded :</span>{" "}
                {getRefundAmount()}
              </p>
              <p>
                <span className="font-semibold">Amount Refunded on :</span>{" "}
                {formatDate(data?.earlyClosureDate) || formatDate(data?.timestamp) || "09-Feb-2026"}
              </p>
              {data?.refundDays > 0 && (
                <p>
                  <span className="font-semibold">Refund Days :</span> {data.refundDays} days
                </p>
              )}
              {data?.refundRemarks && (
                <p>
                  <span className="font-semibold">Remarks :</span> {data.refundRemarks}
                </p>
              )}
            </div>
          </div>

          {/* <!-- Signature Section --> */}
          <div className="mt-16 grid grid-cols-2 gap-10 text-sm">
            <div>
              <p className="font-semibold mb-8">Authorized By:</p>
              <div className="border-t border-black w-64"></div>
              <p className="text-xs mt-1">{data?.updatedBy || ""}</p>
            </div>

            <div>
              <p className="font-semibold mb-8">Cashier's Signature :</p>
              <div className="border-t border-black w-64"></div>
            </div>
          </div>

          <div className="mt-12 text-sm">
            <p className="font-semibold mb-8">Customer's Signature:</p>
            <div className="border-t border-black w-64"></div>
          </div>

          {/* <!-- Terms --> */}
          <div className="mt-12 text-xs text-gray-600">
            <p className="font-semibold">Terms & Conditions</p>
            <p>
              1) In case of Refund, Refunds will be processed within 2 to 3
              working days.
            </p>
            <p>2) Refunds will be processed "online" only.</p>
          </div>
        </div>
      </div>
    </>
  );
});

export default ClosureRefundFormPrintout;